import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';

const Loader = ({ className }) => (
   <div className={ `line-loader ${ className }` } />
);

Loader.propTypes = {
   className: PropTypes.string,
}

export default Loader;

